// -------------------------------------------------    -------------------------
// #55 - Wild Challenge hero module
// --------------------------------------------------------------------------
// Author:      Thomas Jeatt
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;

    function init() {

        var activitiesButton = context.find('[data-binding="wild-challenge-show-activities-button"]');
        var closedStateText = null;

        activitiesButton.on('click', function (e) {

            e.preventDefault();
            var activeButton = $(this);
            var buttonText = activeButton.find('.button__text');
            var openedStateText = activeButton.data('opened-text');
            var activitiesList = activeButton.parents('[data-binding="wild-challenge-activities"]').find('[data-binding="wild-challenge-activities-list"]');

            if (closedStateText === null) {
                closedStateText = buttonText.text();
            }

            activitiesList.slideToggle();

            if (activeButton.hasClass('open')) {
                activeButton.removeClass('open');
                buttonText.text(closedStateText);
            } else {
                activeButton.addClass('open');
                buttonText.text(openedStateText);
            }
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/wild-challenge/wild-challenge-show-activities.js
// module id = 258
// module chunks = 0